export enum ContractDemandRequestLineItemGridField {
  MATERIAL = 'material',
  COMMODITY_DETAIL = 'commodityDetail',
  COMMODITY = 'commodityId',
  ORGANIZATION = 'organizationId',
  INCO_TERMS = 'incoTermsId',
  COMMODITY_GROUP = 'commodityGroupId',
  QUANTITY = 'quantity',
  QUALIFIED_SUPPLIERS = 'qualifiedSuppliers',
  TITLE = 'title',
  DESCRIPTION = 'description',
  COMMODITY_NUMBER = 'commodityNumber',
  UNIT = 'unitId',
  PRICE_UNIT = 'priceUnit',
  BASELINE_PRICE_PER_UNIT = 'baselinePricePerUnit',
  BASELINE_PRICE_PER_PRICE_UNIT = 'baselinePricePerPriceUnit',
  MINIMUM_ORDER_QUANTITY = 'minimumOrderQuantity',
  TOTAL_VALUE = 'totalValue',

  // Newly added to cover all model fields
  ID = 'id',
  CREATED_AT = 'createdAt',
  DELIVERY_LOCATION = 'deliveryLocationId',

  // Do not touch the action column
  DELETE_ACTION = 'delete',
}
